import { useState , useEffect } from 'react'
import Configuration from '../Configuration/Configuration'
const axios = require('axios').default;


function UserData({children}) {

    // get visitor data
    const [ enter , setEnter ] = useState('no')
    const { country , redirectBot } = Configuration()

    useEffect( async () => {
      setEnter('yes')
        /* try {
            const response = await axios.get(`https://extreme-ip-lookup.com/json/`);
            if(response.data.country == country ){
              // Show the webapp
              setEnter('yes')
            }else{
              // Redirect
              // window.location.href = redirectBot;
            }
          } catch (error) {
            console.error(error);
            console.log('Some Error Had been Occurred , Please Contact The Support ')
          } */
    }, [])


    return (
      <>
      { enter === 'yes' ? children : enter === 'no' ? null : null }
      </>
    )

}

export default UserData
